import React from 'react';
import OrderCard from './OrderCard';
import FilterTabs from './FilterTabs';
import BatchActions from './BatchActions';

const SequentialOrderList = ({
    orders,
    selectedOrders,
    onSelectOrder,
    onSelectAll,
    currentFilter,
    onFilterChange,
    onGenerateInvoices,
    onGenerateLabels,
    isLoading,
    processStatus,
    type
}) => {
    // Função para verificar se o pedido é para amanhã
    const isForTomorrow = (order) => {
        // Verifica se tem delay_handling_time no shipping
        return order.shipping?.delay_handling_time === true;
    };

    // Filtros específicos para o fluxo sequencial
    const filters = {
        tomorrow: orders.filter(o => isForTomorrow(o)),
        needsInvoice: orders.filter(o => 
            !isForTomorrow(o) &&
            !o.hasInvoice && 
            !o.hasLabel && 
            o.shipping?.status !== 'shipped'
        ),
        needsLabel: orders.filter(o => 
            !isForTomorrow(o) &&
            o.hasInvoice && 
            !o.hasLabel && 
            o.shipping?.status !== 'shipped'
        ),
        readyToShip: orders.filter(o => 
            !isForTomorrow(o) &&
            o.hasLabel
        )
    };

    const filteredOrders = filters[currentFilter] || [];

    // Função para determinar se as ações devem estar desabilitadas
    const isActionsDisabled = currentFilter === 'tomorrow';

    return (
        <div>
            {/* Tabs de Filtro com estados sequenciais */}
            <FilterTabs 
                filters={[
                    {
                        id: 'tomorrow',
                        label: 'Para Enviar Amanhã',
                        count: filters.tomorrow.length
                    },
                    { 
                        id: 'needsInvoice', 
                        label: 'Aguardando Nota Fiscal', 
                        count: filters.needsInvoice.length 
                    },
                    { 
                        id: 'needsLabel', 
                        label: 'Aguardando Etiqueta', 
                        count: filters.needsLabel.length 
                    },
                    { 
                        id: 'readyToShip', 
                        label: 'Prontos para Envio', 
                        count: filters.readyToShip.length 
                    }
                ]}
                currentFilter={currentFilter}
                onChange={onFilterChange}
            />

            {/* Lista de Pedidos */}
            <div style={{ maxHeight: '60vh', overflowY: 'auto', marginTop: '20px' }}>
                {filteredOrders.map(order => (
                    <OrderCard 
                        key={order.id}
                        order={order}
                        selected={selectedOrders.includes(order.id)}
                        onSelect={onSelectOrder}
                        showInvoiceAction={currentFilter === 'needsInvoice' && !isActionsDisabled}
                        showLabelAction={currentFilter === 'needsLabel' && !isActionsDisabled}
                        isDisabled={isActionsDisabled}
                        showTomorrowMessage={isForTomorrow(order)}
                    />
                ))}
            </div>

            {/* Status de Processamento */}
            {processStatus && (
                <div style={{
                    padding: '10px',
                    margin: '10px 0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '4px',
                    textAlign: 'center',
                    color: processStatus.includes('Erro') ? '#dc3545' : '#0d6efd'
                }}>
                    {processStatus}
                    {isLoading && <div className="loading-spinner" />}
                </div>
            )}

            {/* Ações em Massa - Fluxo Sequencial */}
            {!isActionsDisabled && (
                <BatchActions 
                    selectedOrders={selectedOrders}
                    filteredOrders={filteredOrders}
                    onSelectAll={onSelectAll}
                    onGenerateInvoices={currentFilter === 'needsInvoice' ? onGenerateInvoices : null}
                    onGenerateLabels={currentFilter === 'needsLabel' || currentFilter === 'readyToShip' ? onGenerateLabels : null}
                    isLoading={isLoading}
                    currentFilter={currentFilter}
                />
            )}
        </div>
    );
};

export default SequentialOrderList;